import { render, staticRenderFns } from "./ConversationColor.vue?vue&type=template&id=16c6872a"
import script from "./ConversationColor.vue?vue&type=script&lang=js"
export * from "./ConversationColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports